import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Observable, map } from 'rxjs';

import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { BrmCloudService } from '@shared/brm-cloud.service';
import { MotionRecordingInfo } from '../services/motion-recording-info.interface';
import { MotionDataService } from '../services/motion-data.service';

@Component({
  selector: 'motion-recording-info',
  templateUrl: './recording-info.component.html',
  styleUrls: ['./recording-info.component.scss']
})
export class RecordingInfoComponent implements OnInit {

  cyclistID: string|null = null;
  recordingID: string|null = null;

  recording$: Observable<MotionRecordingInfo|undefined>;

  constructor(private route: ActivatedRoute, public readonly brmCloud: BrmCloudService, private readonly motionData: MotionDataService, private firestore: AngularFirestore, private storage: AngularFireStorage) {

  }

  ngOnInit(): void {
    this.recording$ = this.route.paramMap.pipe(
      switchMap(params => {
        console.log("Params", params)
        this.cyclistID = params.get('cyclistID');
        this.recordingID = params.get('recordingID');

        return this.motionData.getRecordingInfo(this.cyclistID, this.recordingID);
      })
    );

    // TEMP TEST
    this.recording$.subscribe((rec: any) => {
      console.log("subscribed recording next:", rec);
    })
  }
}
